import { useMobileOrientation } from "react-device-detect";

export const useOrientationHook = () => {
  const { isLandscape } = useMobileOrientation();
  return isLandscape;
};
